import { AxiosRequestConfig } from "axios";

export type PatchSubscriptionOptions = {
  authorization?: string;
  xForwardedFor?: string;
};

export const patchSubscriptionConfig = (options: PatchSubscriptionOptions): AxiosRequestConfig => {
  const headers: Record<string, string> = {
    Accept: "*/*",
    "Content-Type": "application/json",
  };

  if (options.authorization) {
    headers.Authorization = `Bearer ${options.authorization}`;
  }

  if (options.xForwardedFor !== undefined) {
    headers["server-side-client-ip"] = options.xForwardedFor;
  }

  return {
    method: "patch",
    url: `/me/subscription/assign`,
    headers,
  };
};
